import { MonitorSmartphone } from 'lucide-react'
import type { ReactNode } from 'react'
import { useNavigate } from 'react-router'
import { Button } from '@/components/ui/button'
import { DESKTOP_QUERY, useMediaQuery } from '@/lib/useMediaQuery'

/**
 * Wraps a screen that is honestly not usable on a phone. The children are only
 * rendered from md up (`useMediaQuery`), so a phone never mounts, and so never
 * loads the data of, a screen it cannot use.
 */
export function DesktopOnly({ children }: { children: ReactNode }) {
  const navigate = useNavigate()
  const desktop = useMediaQuery(DESKTOP_QUERY)
  if (desktop) return <>{children}</>
  return (
    <>
      <div className="vonk-card flex flex-col items-start gap-3 p-6">
        <MonitorSmartphone className="size-6 text-muted-foreground" aria-hidden />
        <div>
          <h2 className="text-base font-semibold">Dit scherm werkt het best op een groter scherm</h2>
          <p className="text-sm text-muted-foreground">
            Open deze pagina op een laptop of desktop. Onderweg kun je het bord, dossiers, taken en
            relaties wel gewoon bekijken.
          </p>
        </div>
        <Button type="button" onClick={() => navigate(-1)}>
          Terug
        </Button>
      </div>
    </>
  )
}
